export default {
  websiteTitle: "Lycee Overture TCG Translation Website",
};
